// Copyright (c) 2016 Deere & Company

import DealerRecommendations from '../../product/dealer-recommendations/state-connector';

export default {
    component: DealerRecommendations,
    name: 'DEALER_RECOMMENDATIONS',
    path: 'dealerrecommendations'
};



// WEBPACK FOOTER //
// ./src/routes/products/dealer-recommendation-route.js